import { gqlRequest } from './gql-request';
import { ReportComparisonUrlQueryVariables } from './graphql/generated';

export type PortalComparisonLinkArgs = {
  /** GraphQL endpoint URL */
  server: string;
  /** API key with write permissions */
  apiKey: string;
  /** GraphQL query variables */
  parameters: ReportComparisonUrlQueryVariables;
  /** GraphQL request timeout in minutes */
  timeout?: number;
};

/**
 * Fetches link to Code PushUp portal comparison page.
 * @param args GraphQL endpoint configuration and query variables.
 * @returns Report comparison URL
 */
export async function getPortalComparisonLink(
  args: PortalComparisonLinkArgs,
): Promise<string | undefined> {
  const { server, apiKey, parameters: variables, timeout } = args;
  const data = await gqlRequest({
    operation: 'reportComparisonUrl',
    server,
    apiKey,
    variables,
    timeout,
  });
  return data.project?.reportComparison?.url;
}
